import React from 'react';

import PropTypes from 'prop-types';

import SideNavigation from '@adsk/alloy-side-navigation';
import TopNavigation from '@adsk/alloy-top-navigation';

import SideNavigationLayout from './SideNavigationLayout';
import TopNavigationLayout from './TopNavigationLayout';

/**
 * Skeleton for page navigation frame, housing navigation components.
 */
const NavigationLayout = React.forwardRef(
  (
    {
      children,
      renderSideNavigation,
      renderTopNavigation,
      renderAboveLayout,
      ...props
    },
    ref,
  ) => (
    <TopNavigationLayout
      {...props}
      ref={ref}
      renderTopNavigation={renderTopNavigation}
      renderAboveLayout={renderAboveLayout}
    >
      <SideNavigationLayout renderSideNavigation={renderSideNavigation}>
        {children}
      </SideNavigationLayout>
    </TopNavigationLayout>
  ),
);

NavigationLayout.displayName = 'NavigationLayout';

NavigationLayout.defaultProps = {
  renderSideNavigation: (props) => <SideNavigation {...props} />,
  renderTopNavigation: (props) => <TopNavigation {...props} />,
};

NavigationLayout.propTypes = {
  /** Page content */
  children: PropTypes.node,
  /** Side navigation render function */
  renderSideNavigation: PropTypes.func,
  /** Top navigation render function */
  renderTopNavigation: PropTypes.func,
  /** Items that will render above the layout*/
  renderAboveLayout: PropTypes.func,
};

export default NavigationLayout;
